import { computed } from 'vue'

export function useButton (props, variant = null) {
  if (variant.value) {
    props.value.variant = variant.value
  }

  const computedVariantClasses = computed(() => {
    if (props.value.disabled) {
      if (['poutline', 'ghost', 'gprimary', 'dark-ghost', 'gdanger'].includes(props.value.variant)) {
        return 'px-2  py-2 rounded  border-transparent bg-transparent text-gray-400 cursor-notallowed cursor-not-allowed'
      }

      return props.variant !== 'link' ? 'px-2  py-2 bg-gray-50 rounded  border-transparent bg-transparent text-gray-300 cursor-notallowed cursor-not-allowed ' : 'text-gray-300 t'
    }
    return {
      poutline: 'cursor-pointer shadow-sm border border-blue-200 rounded relative text-blue-500 bg-transparent hover:bg-blue-50 hover:border-blue-300  focus:border-transparent focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-blue-200',
      outline: 'cursor-pointer shadow-sm border border-neutral-200 rounded relative text-neutral-900 bg-transparent hover:bg-neutral-100 hover:border-neutral-300  focus:border-transparent focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-neutral-200',
      primary: 'cursor-pointer shadow-sm border border-transparent rounded relative text-white bg-blue-600 hover:bg-blue-500  focus:border-white focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-blue-700',
      danger: 'cursor-pointer shadow-sm border border-transparent rounded relative text-white bg-red-600 hover:bg-red-500  focus:border-white focus:outline-none focus:ring-2 ring-offset-white focus:ring-red-500 active:bg-red-700',
      solid: 'cursor-pointer shadow-sm border border-neutral-300 rounded relative text-neutral-900 bg-neutral-200 hover:bg-neutral-300 hover:border-neutral-400  focus:border-transparent focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-neutral-200',
      solidWhite: 'cursor-pointer shadow-sm border border-neutral-300 rounded relative text-neutral-900 bg-white hover:bg-neutral-300 hover:border-neutral-400  focus:border-transparent focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-neutral-200',
      light: 'cursor-pointer shadow-sm border border-transparent rounded relative text-neutral-900 bg-neutral-100 hover:bg-neutral-200 hover:border-transparent  focus:border-transparent focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-neutral-300',
      ghost: 'cursor-pointer border border-transparent rounded text-center text-neutral-900 bg-transparent hover:bg-neutral-100 hover:border-neutral-300 focus:outline-none  focus:border-blue-400  focus:ring-2 focus:ring-blue-200 focus:outline-none active:bg-neutral-200',
      gdanger: 'cursor-pointer border border-transparent rounded text-center text-red-500 bg-transparent hover:bg-red-500 hover:text-white hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 active:!bg-red-50 focus:text-red-400 focus:border-red-400',
      gprimary: 'cursor-pointer border border-transparent rounded relative text-blue-500 hover:text-white  hover:bg-blue-400  focus:border-white focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-blue-700',
      iconbar: 'cursor-pointer border rounded border-transparent text-center text-gray-100 bg-transparent hover:text-yellow-500 focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-neutral-900',
      link: 'cursor-pointer border border-transparent text-blue-500 bg-transparent hover:text-blue-600 hover:border-neutral-300 focus:outline-none  focus:border-blue-400  focus:ring-2 focus:ring-blue-200 focus:outline-none active:bg-neutral-900',
      'dark-ghost': 'cursor-pointer border border-transparent rounded text-center text-white hover:text-black bg-transparent hover:bg-neutral-100 hover:border-neutral-300 focus:outline-none  focus:border-blue-400  focus:ring-2 focus:ring-blue-200 focus:outline-none active:bg-neutral-200'
    }[props.value.variant || 'ghost']
  })

  const getSize = computed(() => {
    return {
      lg: 'h-10 w-10',
      md: 'h-8 w-8',
      sm: '!size-6',
      full: 'w-full h-8',
      auto: 'h-8 text-sm',
      link: 'm-0'
    }[props.value.size]
  })

  const getIconSize = computed(() => {
    return {
      lg: 'h-7 w-7',
      sm: 'h-5 w-5',
      md: 'h-5 w-5',
      full: 'h-5 h-5',
      auto: 'h-5 h-5'
    }[props.value.size]
  })

  const getVariant = computed(() => {
    let classes = props.value.disabled || props.value.loading ? disable(computedVariantClasses.value) : computedVariantClasses.value
    if (props.value.active) {
      classes = classes + ' active'
    }

    if (props.value.disabled || props.value.loading) {
      classes = classes + ' cursor-not-allowed'
    }

    if (props.value.removeBorder) {
      classes = removeClasses(classes, ['border', 'hover:border', 'rounded'])
    }

    if (props.value.active === true && props.value.variant === 'iconbar') {
      classes = classes.replace('bg-transparent', 'bg-gray-800')
      classes = classes.replace('text-white', 'text-yellow-500')
    }

    return props.value.focusOnClick ? classes : removeClasses(classes, ['focus:', 'active:'])
  })

  const removeClasses = (classes, classesToRemove) => {
    const removes = []
    classes = classes.split(' ')

    for (const name of classes) {
      for (const remove of classesToRemove) {
        if (name.startsWith(remove)) {
          removes.push(name)
        }
      }
    }

    classes = classes.filter(item => !removes.includes(item))
    return classes.join(' ')
  }

  const disable = (classes) => {
    classes = classes.replace(
      props.value.variant === 'ghost' ? 'bg-transparent' : '',
      props.value.variant === 'primary' ? 'bg-blue-600' : '',
      props.value.variant === 'primary' ? 'bg-gray-300' : '',
      props.value.variant === 'iconbar' ? 'bg-tnRed' : 'text-gray-600'
    )
    classes = classes.replace(
      props.value.variant === 'primary' ? 'text-white' : 'text-neutral-900',
      props.value.variant === 'primary' ? 'text-gray-500' : 'text-neutral-300',
      props.value.variant === 'iconbar' ? 'text-white' : 'text-gray-600'
    )
    classes = classes.replace('cursor-pointer', '')

    return removeClasses(classes, [
      'active:', 'hover:', 'focus:'
    ])
  }

  const getClasses = computed(() => getVariant.value + ' ' + getSize.value)
  return { getClasses, getIconSize }
}
